import { render, staticRenderFns } from "./Candidate-list.vue?vue&type=template&id=16654c0c&scoped=true&"
import script from "./Candidate-list.vue?vue&type=script&lang=js&"
export * from "./Candidate-list.vue?vue&type=script&lang=js&"
import style0 from "./assets/index.less?vue&type=style&index=0&id=16654c0c&scoped=true&lang=less&"
import style1 from "./Candidate-list.vue?vue&type=style&index=1&id=16654c0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16654c0c",
  null
  
)

export default component.exports